export default {
    newDesign: true,
    parameters: {
        landing_id: "TrQRob",
        segment: 11,
        success_page: "success_long",
    },
    title:
        "5 soruyu yanıtlayın ve çocuğunuz için ücretsiz bir Roblox programlama dersi kazanın | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    startPage: {
        title:
            "5 soruyu yanıtlayın ve çocuğunuz için ücretsiz bir Roblox programlama dersi kazanın",
        subtitle:
            "60 dakikada çocuğunuz bir eğitmenle programlamanın temellerini öğrenecek ve ilk mini projesini yapacak.",
        image: {
            url: "/welcome/tr_roblox_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_roblox_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Başlayalım 🚀",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimiz için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyarız!",
    },
    customStopPages: {
        child: {
            title: "Maalesef, bir öğrenciyi derslere yalnızca bir ebeveyn veya vasi kaydedebilir.",
            subtitle:
                "Devam etmek istiyorsanız bu bağlantıyı ebeveyninizle paylaşabilirsiniz. Sizi en kısa sürede derslerimizde görmeyi umuyoruz!",
            image: "/welcome/quizV2/child-parent.png",
        },
    },
    quizRotateBySteps: {
        1: {
            question: "Bu testi kim dolduruyor?",
            answers: [
                "👩 Anne veya babayım",
                "👶 Başka bir aile üyesi / vasiyim",
                {
                    answer: "🧒 Çocuğun kendisiyim",
                    stopAnswer: true,
                    customStopPageId: "child",
                },
            ],
        },
        2: {
            question:
                "Çocuğunuzun Roblox ile ilişkisini nasıl tanımlarsınız?",
            answers: [
                "🎮 Oynamayı çok seviyor ama aynı zamanda bir şeyler yaratmasını da istiyorum.",
                "🌟 Çok yaratıcı ve sürekli yeni dünyalar hayal ediyor.",
                "🤔 Ekran başında çok vakit geçiriyor, bunun verimli olmasını istiyorum.",
                "🎨 Avatarını ve tasarımı kişiselleştirmeyi seviyor.",
            ],
        },
        3: {
            question: "Çocuğunuzun hobisini öğrenmeye dönüştürerek ne kazanmasını istersiniz?",
            answers: [
                "🚀 Sadece oynamayı değil, kendi oyunlarını yaratmayı öğrenmesini.",
                "💡 Mantıksal düşünme ve programlama becerisi geliştirmesini.",
                "🛡️ İnternette güvenli bir şekilde gezinmeyi öğrenmesini.",
                "📈 Teknolojinin nasıl çalıştığını içeriden anlamasını.",
            ],
        },
        4: {
            question: "Çalışabileceğiniz bir masaüstü veya dizüstü bilgisayarınız var mı?",
            answers: [
                "💻 Evet",
                {
                    answer: "😕 Hayır",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            title: "Çocuğunuz kaç yaşında?",
            type: "age",
            button: "",
        },
        6: {
            typeInfo: "congrats",
            title: "🎉 Ücretsiz dersiniz için her şey hazır!",
            subtitle:
                "Sonraki adımda iletişim bilgilerinizi bırakın, ardından size en uygun gün ve saati seçin.",
            button: "📅 Ücretsiz dersi ayırt",
        },
        7: {
            title: "Ücretsiz deneme dersine kaydolun",
            type: "one-page-contacts",
            subtitle:
                "Tanışalım, yöntemimizi keşfedin ve çocuğunuzun bizimle neler öğrenebileceğini görün.",
            button: "Neredeyse bitti 🔥",
        },
        8: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        10: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        11: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        },
    },
};
